'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useAccordionSectionContext } from './Section';
import * as Styles from './styles';
import { useAccordionContext } from '.';
export const AccordionBody = ({ children, className }) => {
    const { variant, showBorder, withAnimation } = useAccordionContext();
    const { id } = useAccordionSectionContext();
    return (_jsx(Styles.Details, { animate: withAnimation, "$withAnimation": withAnimation, "$showBorder": showBorder, "$variant": variant, className: className, id: `content-${id}`, children: children }));
};
//# sourceMappingURL=Body.js.map